<template>
    <div class="result_box">
        <div v-show="applyStatus == '1'">
            <img class="result_img" src="@/assets/img/mobile-img/sign-pending.png" alt="" />
            <p class="result_title">提交成功，等待平台审核</p>
            <p class="result_tip">预计1-3个工作日完成,审核结果将通过短信通知您</p>
            <van-button class="result_btn" color="#4A79F1" round plain hairline @click="toHome"
                >返回首页</van-button
            >
        </div>
        <div v-show="applyStatus == '2'">
            <img class="result_img" src="@/assets/img/mobile-img/sign-success.png" alt="" />
            <p class="result_title">入驻成功</p>
            <p class="result_tip">
                恭喜您成为中文知识网知识合伙人，请返回首页选择开通知识合伙人相关权益！
            </p>
            <van-button class="result_btn" color="#4A79F1" round plain hairline @click="toHome">
                返回首页
            </van-button>
        </div>
        <div v-show="applyStatus == '3'">
            <img class="result_img" src="@/assets/img/mobile-img/sign-fail.png" alt="" />
            <p class="result_title">审核失败</p>
            <p class="result_tip">
                抱歉，您提交的知识合伙人申请未通过平台审核，请依据审核意见修改后再次提交
            </p>
            <div v-if="failCause" class="result_fail_text">{{ failCause }}</div>
            <van-button round type="info" class="result_fail_btn" @click="againSign">
                重新申请
            </van-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            applyStatus: "",
            failCause: "",
        };
    },
    created() {
        this.getStatus();
    },
    methods: {
        async getStatus() {
            const res = await this.$apis.userServe.getPartnerDetail();
            if (res.resultCode === "200") {
                if (res.data.review) {
                    // auditStatus： 1 待审核， 2 成功， 3 失败
                    this.applyStatus = res.data.review.auditStatus;
                    if (res.data.review.auditStatus == 3) {
                        this.failCause = res.data.review.auditOpinion;
                    }
                }
            }
        },
        againSign() {
            if (sessionStorage.getItem("token")) {
                let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
                console.log(userInfo);
                let customerType = userInfo.user.customerType; // 1 普通用户 2学者 4 期刊 5 机构 没有 子账号
                if (customerType == 2 || customerType == 4 || customerType == 5) {
                    this.$router.push({
                        path: "/partner/form-service",
                        query: { customerType, isFail: true },
                    });
                }
            } else {
                this.$router.push("/logins");
            }
        },
        toHome() {
            console.log("this.$store.state.isApp", this.$store.state.isApp);
            if (this.$store.state.isApp) {
                // 有out代表是APP进入
                if (this.$global.isAndroid_ios()) {
                    window.android.gubeit();
                } else {
                    window.webkit.messageHandlers.gubeit.postMessage("null"); //ios
                }
                return;
            }
            this.$router.push({ path: "/" });
        },
    },
};
</script>

<style lang="scss" scoped>
.result_box {
    position: relative;
    padding-top: 120px;
    min-height: calc(100vh - 44px);
    overflow: hidden;
    text-align: center;
    .result_img {
        width: 96px;
        height: 92px;
    }
    .result_title {
        margin-top: 11px;
        text-align: center;
        font-size: 15px;
        color: #333333;
    }
    .result_tip {
        margin-top: 12px;
        padding: 0 45px;
        font-size: 13px;
        color: #999999;
    }
    .result_btn {
        margin: 55px auto 0;
        width: 117px;
        height: 40px;
    }
    .result_fail_text {
        margin: 20px auto 0;
        padding: 15px;
        width: 351px;
        background: #f5f5f5;
        border-radius: 8px;
        font-size: 13px;
        color: #333333;
        word-break: break-all;
    }
    .result_fail_btn {
        margin-top: 18px;
        width: 315px;
        height: 44px;
    }
}
</style>
